import {
  SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { CountryConfigurationUrls } from '@rover/rsdk/src/apiClient/latest/model/countryConfigurationUrls';
import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import { useCurrentCountryConfiguration } from '@rover/rsdk/src/modules/Data/Core/CountryConfiguration';
import { PetType } from '@rover/types/src/Pet';
import { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';
import {
  getIsPriceTransparencyCondensed,
  getIsPriceTransparencyFull,
} from '@rover/utilities/priceTransparency';

import { selectRateForPetType, usePrimaryPetType } from '../utils/utils';

import { useRevampProfileContext } from './useRevampProfileContext';

type RevampCtaData = {
  countryConfigUrls: CountryConfigurationUrls | undefined;
  isPtFull: boolean;
  isPtCondensed: boolean;
  displayPetType: PetType;
  petTypeServices: EnhancedPersonSitterProfile['services'];
  rate: EnhancedPersonSitterProfile['services'][number]['serviceAddOns'][number] | undefined;
  price: string | null | undefined;
};

export const useRevampCtaCommon = (
  priceTransparencyLevel: PriceTransparencyLevel,
  petType: SearchParamsPetType,
  petCount: SearchParamsPetCounts,
  selectedService: EnhancedPersonSitterProfile['services'][number] | undefined
): RevampCtaData => {
  const { sitterData } = useRevampProfileContext();
  const { urls: countryConfigUrls } = useCurrentCountryConfiguration();

  const isPtFull = getIsPriceTransparencyFull(priceTransparencyLevel);

  const petTypeServices = selectedService ? [selectedService] : sitterData.services;
  const displayPetType = usePrimaryPetType(petCount, petType, petTypeServices);

  const rate = selectedService
    ? selectRateForPetType(selectedService.serviceAddOns, displayPetType)
    : undefined;

  const price = isPtFull ? rate?.fullPricePerUnit : rate?.pricePerUnit;

  const isPtCondensed = getIsPriceTransparencyCondensed(priceTransparencyLevel);

  return {
    countryConfigUrls,
    isPtFull,
    isPtCondensed,
    displayPetType,
    petTypeServices,
    rate,
    price,
  };
};
